import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenRotationAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screen_rotation_alt"}/>
}
